import {
    ORDERSLIST_REQUEST,
    ORDERSLIST_ERROR,
    ORDERSLIST_SUCCESS,
    ORDERSLIST_params
} from "../actions/ordersList";
import { ORDERDETAILS_REQUEST } from "../actions/ordersDetails";
import { PRODUCTSLIST_REQUEST } from "../actions/productsList";
import { NONDELIVERYREASONS_REQUEST } from "../actions/nonDelivery";
import Vue from "vue";
import apiCalls from "utils/api";
import store from '../../store';

const state = {
    ordersList: [],
    status: "",
};

const getters = {
    getOrdersList: state => state.ordersList,
    getOrderById(state) {
        return keyword => state.ordersList.find(item => {
            var id = parseInt(keyword);
            return item.ShipmentId === id
        });
    },
    isOrdersListHasItems: state => !!state.status.length,
    ordersListStatus: state => state.status
};

const actions = {
    [ORDERSLIST_REQUEST]: ({ commit, dispatch }) => {
        commit(ORDERSLIST_REQUEST);

        var driverId = store.state.driver.driverInfo.DriverId;
        var filter = [
            {
                Filters: [
                    {
                        name: 'DriverId',
                        value: driverId,
                        operator: '='
                    },
                    {
                        name: 'TripDate',
                        value: new Date().toISOString().slice(0, 19).slice('T', 10).split('-').reverse().join('-'), //'12-08-2020' - has items
                        operator: '='
                    }
                ]
            }
        ];
        ORDERSLIST_params.filter = JSON.stringify(filter);

        apiCalls.apiCall({ url: "get", method: "GET", params: ORDERSLIST_params })
            .then(resp => {
                commit(ORDERSLIST_SUCCESS, resp.data);
                
                dispatch(ORDERDETAILS_REQUEST);
                dispatch(PRODUCTSLIST_REQUEST);
                dispatch(NONDELIVERYREASONS_REQUEST);
                //dispatch(LISTILT_REQUEST);              
            })
            .catch(() => {
                commit(ORDERSLIST_ERROR);
            });
    }
};

const mutations = {
    [ORDERSLIST_REQUEST]: state => {
        state.status = "loading";
    },
    [ORDERSLIST_SUCCESS]: (state, resp) => {
        state.status = "success";
        state.ordersList = resp.data;
        Vue.set(state, "ordersList", resp.data);
    },
    [ORDERSLIST_ERROR]: state => {
        state.status = "error";
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
